import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { API, SITE_DEFAULTS } from '../config/site';

const MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

// Auto mode: start = next month, one more slot taken each week (week 1: total-1 free ... week 4+: total-4 free, min 1).
export const applyAutoSlots = (c, now = new Date()) => {
  if (!c.slots_auto) return c;
  const week = Math.min(4, Math.ceil(now.getDate() / 7));
  return { ...c, next_start: MONTHS[(now.getMonth() + 1) % 12], slots_free: Math.max(1, c.slots_total - week) };
};

const SiteConfigContext = createContext({ config: SITE_DEFAULTS, raw: SITE_DEFAULTS, reload: () => {} });

export const SiteConfigProvider = ({ children }) => {
  const [raw, setRaw] = useState(SITE_DEFAULTS);

  const reload = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/settings`);
      setRaw({ ...SITE_DEFAULTS, ...data });
    } catch {
      setRaw(SITE_DEFAULTS);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return (
    <SiteConfigContext.Provider value={{ config: applyAutoSlots(raw), raw, reload }}>
      {children}
    </SiteConfigContext.Provider>
  );
};

export const useSiteConfig = () => useContext(SiteConfigContext).config;
export const useRawSiteConfig = () => useContext(SiteConfigContext).raw;
export const useReloadSiteConfig = () => useContext(SiteConfigContext).reload;
